var React = require('react');

function HamBurger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"9","width":"29","height":"2","fill":"white","key":0}),React.createElement("rect",{"width":"29","height":"2","fill":"white","key":1}),React.createElement("rect",{"y":"18","width":"29","height":"2","fill":"white","key":2})]);
}

HamBurger.defaultProps = {"width":"29","height":"20","viewBox":"0 0 29 20","fill":"none"};

module.exports = HamBurger;

HamBurger.default = HamBurger;
